import { FacebookPage } from "../types";

export async function jobberAccountName(state: string): Promise<{ account_name: string }> {
    const response = await fetch("/auth/jobber/account_name", {
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Jobber account name: ${response.status}`);
    }
    return response.json();
}

export async function jobberAuthorize(code: string | null): Promise<{ state: string }> {
    const params = new URLSearchParams();
    if (code) params.set("code", code);

    const response = await fetch(`/auth/jobber/authorize?${params}`, {
        method: "POST",
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error(`Jobber authorization failed: ${response.status}`);
    }
    return response.json();
}

export async function jobberRedirectUrl(): Promise<{ redirect_url: string }> {
    const response = await fetch("/auth/jobber/redirect_url", {
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Jobber redirect URL: ${response.status}`);
    }
    return response.json();
}

export async function facebookAuthorize(code: string, state: string): Promise<{ state: string }> {
    const params = new URLSearchParams();
    params.set("code", code);

    const response = await fetch(`/auth/facebook/authorize?${params}`, {
        method: "POST",
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Facebook authorization failed: ${response.status}`);
    }
    return response.json();
}

export async function facebookRedirectUrl(state: string): Promise<{ redirect_url: string }> {
    const response = await fetch("/auth/facebook/redirect_url", {
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Facebook redirect URL: ${response.status}`);
    }
    return response.json();
}

export async function saveFacebookPage(
    state: string,
    page: FacebookPage,
): Promise<void> {
    const response = await fetch("/auth/facebook/select_page", {
        method: "POST",
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ page_id: page.id }),
    });
    if (!response.ok) {
        throw new Error("We couldn't save your Facebook Page selection in Jobber. Please try again — if it keeps happening, reconnect your Jobber account.");
    }
}

export async function getFacebookPages(state: string): Promise<FacebookPage[]> {
    const response = await fetch("/auth/facebook/pages", {
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Facebook Pages: ${response.status}`);
    }
    const body: { pages: FacebookPage[] } = await response.json();
    return body.pages;
}
